

export default function (_axios, _store, _router) {
    // Intercept all ajax requests
    _axios.interceptors.request.use(
        function (config) {
            // Do something before request is sent
            _store.dispatch('appLoading');
            // console.log(config)
            return config;
        },
        function (error) {
            // Do something with request error
            return Promise.reject(error).then(error => {
                _store.dispatch('stopAppLoading');
                _store.dispatch('addErrorMessage', error)
            });
        }
    );

    // Intercept all ajax responses
    _axios.interceptors.response.use(
        function (response) {
            // Do something with response data
            _store.dispatch('stopAppLoading');

            return response;
        },
        function (err) {
            _store.dispatch('stopAppLoading');
            // console.log('Error response')
            // console.log(err.response)
            return new Promise((resolve, reject) => {
                if (!err.response) {
                // console.log('Network error')
                    // network error
                    const message = 'Error: Network Error';
                    _store.dispatch('addErrorMessage', message)
                    resolve(err);
                }
                else if (err.response &&
                    err.response.status === 500
                ) {
                // console.log('Error code 500')
                    const message = 'Server error, please try again later';
                    _store.dispatch('addErrorMessage', message)
                    reject(err.response);
                }
                else if (err.response &&
                    err.response.status === 401
                ) {
                    _store.commit("logout");
                    const path = '/login'
                    if (_router.currentRoute.path !== path) _router.push(path)

                    reject(err.response);
                }
                // console.log('Rejecting response')
                reject(err.response);
            });
        }
    );
}
